import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import UpdateProductMergeDefaultMutation from '@/graphql/contracts/updateProductMergeDefault.mutation.gql';
import { UpdateProductMergeDefault, UpdateProductMergeDefaultVariables }
  from '@/graphql/contracts/_generated_/updateProductMergeDefault.mutation';

export default function useUpdateProductMergeDefault() {
  const [updateProductMergeDefault, { loading, error }] = useMutation<
  UpdateProductMergeDefault,
  UpdateProductMergeDefaultVariables
  >(UpdateProductMergeDefaultMutation, {
    client: apolloClientContracts,
    refetchQueries: ['GetPaginatedFilteredProducts'],
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const updateMergeDefault = (fields: UpdateProductMergeDefaultVariables, successCb?: () => void) => {
    updateProductMergeDefault({
      variables: { ...fields },
      onCompleted: () => {
        notificationService.open({
          title: 'Product Merge Default',
          text: 'Product merge default successfully updated',
          type: 'success',
        });

        if (successCb) {
          successCb();
        }
      },
    });
  };

  return {
    updateMergeDefault,
    isLoadingUpdateMergeDefault: loading,
    errorUpdateMergeDefault: error,
  } as const;
}
